exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ReactPasswordStrength-strength-desc {\n  font-size: 13px;\n  margin-right: 20px;\n  width: 30%;\n}\n\n.ReactPasswordStrength-strength-bar {\n  margin-top: -1px;\n  left: 1px;\n}\n\n.ReactPasswordStrength-input {\n  padding: 6px 12px;\n  margin-top: 2px;\n  font-size: 13px;\n  color: #000 !important;\n}\n\n.disabled-loading {\n  background-color: #425cc7 !important;\n  border-color: #425cc7 !important;\n  color: #fff !important;\n  opacity: 1 !important;\n}\n", ""]);

// exports
